"use strict";

exports.__esModule = true;
exports.DropdownTitle = exports.ArrowIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _glyph = _interopRequireDefault(require("../glyph"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["isOpen"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ArrowIcon = (0, _styledComponents["default"])(function (_ref) {
  var isOpen = _ref.isOpen,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_glyph["default"], _extends({
    id: "caret-down"
  }, props));
}).withConfig({
  displayName: "components__ArrowIcon",
  componentId: "sc-8vdeif-0"
})(["", ";transform:rotate(", "deg);"], (0, _styles.transitionEase)("0.25s", ["transform"]), function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? "-180" : "0";
});
exports.ArrowIcon = ArrowIcon;

var DropdownTitle = function DropdownTitle(_ref3) {
  var children = _ref3.children,
      searchIcon = _ref3.searchIcon,
      show = _ref3.show;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    flexDirection: ["row-reverse", "row-reverse", "row"],
    justifyContent: ["flex-end", "flex-end", "space-between"],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center"
  }, children, /*#__PURE__*/_react["default"].createElement(ArrowIcon, {
    cursor: "pointer",
    fill: "body-grey",
    height: 12,
    isOpen: show,
    width: 12
  })), searchIcon);
};

exports.DropdownTitle = DropdownTitle;
DropdownTitle.propTypes = {
  children: _propTypes.node,
  searchIcon: _propTypes.node,
  show: _propTypes.bool
};
DropdownTitle.displayName = "Modules.ListDropdownTitle";